import Mirador from "mirador";

// For annotations and storage adapters. Only one is useful.
// see https://github.com/ProjectMirador/mirador-annotations/blob/master/demo/src/index.js
import miradorAnnotationPlugins from 'mirador-annotations';
import miradorLocalStorageAdapter from 'mirador-annotations/lib/LocalStorageAdapter';
import miradorAnnototAdapter from 'mirador-annotations/lib/AnnototAdapter';

// Usual or light plugins.
import { miradorImageToolsPlugin } from 'mirador-image-tools';
import miradorImageDl from 'mirador-dl-plugin';
import ocrHelper from '@4eyes/mirador-ocr-helper';
//import miradorRuler from '../node_modules/mirador-ruler-plugin';
import miradorShare from 'mirador-share-plugin';
import miradorTextOverlay from 'mirador-textoverlay';

window.Mirador = Mirador;

// The used plugins is specified in the main js.
window.miradorPlugins = [
  {name: "annotations", plugin: miradorAnnotationPlugins},
  {name: "image-tools", plugin: miradorImageToolsPlugin},
  {name: "dl", plugin: miradorImageDl},
  {name: "ocr-helper", plugin: ocrHelper},
  // {name: "ruler" , plugin: miradorRuler},
  {name: "share" , plugin: miradorShare},
  {name: "textoverlay", plugin: miradorTextOverlay},
];

// The endpoint of the external annotation server is set in the main js
// through Omeka config.
// @see \Mirador\View\Helper\Mirador::render().
// @see module Mirador asset/js/mirador.js
// To test it, you can uncomment this line:
// const annotationEndpoint = 'http://127.0.0.1:3000/annotations';

// Bridge to store annotations.
window.miradorAnnotationServerAdapter = typeof annotationEndpoint !== 'undefined' && annotationEndpoint
  ? (canvasId) => { return new miradorAnnototAdapter(canvasId, annotationEndpoint); }
  : (canvasId) => new miradorLocalStorageAdapter(`localStorage://?canvasId=${canvasId}`);
